"use strict";(()=>{var I=(n,t,e)=>new Promise((a,i)=>{var s=o=>{try{l(e.next(o))}catch(d){i(d)}},r=o=>{try{l(e.throw(o))}catch(d){i(d)}},l=o=>o.done?a(o.value):Promise.resolve(o.value).then(s,r);l((e=e.apply(n,t)).next())});var q=/-T$/,$="-TP",L=n=>{if(!(n instanceof Element))return null;let t=n.closest(".card-js");return t instanceof HTMLElement?t:null},C=n=>n instanceof HTMLElement?n:null,w=(n,t)=>{var e;n.setAttribute("aria-disabled",t?"true":"false"),n.classList.toggle("loading",t),(e=n.querySelector(".loading-overlay"))==null||e.classList.toggle("hidden",!t)},N=n=>n.replace(q,$),H=n=>{let t=N(n.variantLabel),e=t!==n.variantLabel?t:"";return{id:n.variantId,quantity:1,properties:{_groupId:n.groupId,_url:n.url,_page_of_purchase:window.location.pathname,_isAddon:!1,_isUpgradable:!0,_currentAvailableUpgradeVariants:e,_currentAvailableUpgradeSKU:e}}},v=n=>typeof n=="object"&&n!==null,k=n=>v(n)?typeof n.src=="string"&&typeof n.width=="number"&&typeof n.height=="number"&&typeof n.alt=="string":!1,V=n=>v(n)?typeof n.src=="string"&&typeof n.srcset=="string"&&typeof n.width=="number"&&typeof n.height=="number"&&typeof n.alt=="string":!1,D=n=>v(n)?k(n.pip)&&V(n.main):!1,R=n=>{if(!n)return[];let t=n.dataset.calloutPipList;if(!t)return[];try{let e=JSON.parse(t);return Array.isArray(e)?e.filter(D):[]}catch(e){return console.error("callout PIP list parse error",{error:e,pipListJson:t}),[]}},O=n=>{let t=Number(n.dataset.calloutPipIndex);return Number.isFinite(t)&&t>=0?t:0},B=(n,t)=>{n.dataset.calloutPipIndex=String(t)},P=(n,t)=>{"srcset"in t?(n.srcset=t.srcset,n.src=t.src):(n.src=t.src,n.srcset=""),n.width=t.width,n.height=t.height,n.alt=t.alt},F=n=>{var r,l;let t=n.querySelector(".media > img.active");if(!t)return;let e=t.dataset.calloutBaseSrc;if(!e)return;let a=(r=t.dataset.calloutBaseSrcset)!=null?r:"",i=Number(t.dataset.calloutBaseWidth),s=Number(t.dataset.calloutBaseHeight);!(i>0)||!(s>0)||P(t,{src:e,srcset:a,width:i,height:s,alt:(l=t.dataset.calloutBaseAlt)!=null?l:""})},_=(n,t)=>{let e=n.querySelector("img");e&&P(e,t)},j=(n,t)=>{let e=n.querySelector(".media > img.active");e&&P(e,t)},J=n=>n.querySelector("button.callout-pip.is-active:not([hidden])"),x=(n,t)=>{let e=R(n);if(e.length===0)return null;let a=t?0:O(n);return{items:e,index:a%e.length}};Alpine.data("card",()=>({id:"",variant:"",sku:"",url:"",isAlertMessageShown:!1,init(){setTimeout(()=>{var e;let t=L(this.$el);t&&(this.sku=t.querySelector(".media > img.active")?.dataset.sku||t.dataset.initialSku||"",(e=t.querySelector(".swatch-wrapper[first-button]"))==null||e.click(),this.syncCalloutPip())})},syncCalloutPip(){var p;let t=L(this.$el);if(!t)return;F(t),t.classList.remove("is-callout-pip-swapped");let e=this.id,a=t.querySelectorAll("button[data-callout-pip]"),i=null,s=null,r=null;for(let c of a){let g=c.dataset.calloutPip;g==="product"?i=c:g==="variant"&&(c.classList.contains("is-active")&&(s=c),e&&c.dataset.calloutPipId===e&&(r=c))}s&&s!==r&&(s.hidden=!0,s.classList.remove("is-active"));let l=r!=null?r:i;if(!l)return;if(r&&(r.hidden=!1,r.classList.add("is-active")),i){let c=l===i;i.hidden=!c,i.classList.toggle("is-active",c)}let o=x(l,!0);if(!o)return;let d=t.querySelector(".media > img.active"),f=(p=d==null?void 0:d.dataset.calloutBaseSrc)!=null?p:null,m=o.index;f&&o.items.length>1&&o.items[m].main.src===f&&(m=1),B(l,m),_(l,o.items[m].pip)},swapCalloutPip(){let t=L(this.$el);if(!t)return;let e=J(t);if(!e)return;if(e.dataset.calloutPip!=="variant"){t.classList.toggle("is-callout-pip-swapped");return}let a=x(e,!1);if(!a||a.items.length<2)return;let i=a.items[a.index],s=(a.index+1)%a.items.length,r=a.items[s];j(t,i.main),_(e,r.pip),B(e,s)},updateUrl(){let t=new URLSearchParams;t.set("variant",this.id),this.url=`${this.$el.dataset.url}?${t.toString()}`},openAlertBoxHandle(){this.isAlertMessageShown=!0,setTimeout(()=>{this.isAlertMessageShown=!1},2e3)},submitCartAdd(t,e,a){return I(this,null,function*(){try{w(t,!0);let i={items:e},s=yield fetch(window.routes.cart_add_url,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(i)});if(!s.ok)throw new Error(`Cart add failed: ${s.status}`);yield utils.updateElements([".header__icon--cart"]),this.openAlertBoxHandle(),typeof window.twoNuOpenCartDrawer=="function"&&window.twoNuOpenCartDrawer(),typeof window.twoNuOpenOrdinaryCartAfterAdd=="function"&&window.twoNuOpenOrdinaryCartAfterAdd(),typeof window.twoNuRefreshDockCart=="function"&&window.twoNuRefreshDockCart()}catch(i){console.error({error:i})}finally{w(t,!1),a&&setTimeout(()=>{window.open(window.routes.cart_url,"_self")},200)}})},select(){var g,A,E,T,M;let t=(g=this.$el.parentNode)==null?void 0:g.querySelectorAll(".swatch-wrapper");t==null||t.forEach(u=>u.classList.remove("active")),this.$el.classList.add("active");let e=this.$el.closest(".card-js"),a=(A=e==null?void 0:e.querySelector(".media > img.active"))!=null?A:null,i=e==null?void 0:e.querySelectorAll(".media > img"),s=e==null?void 0:e.querySelector(".buy-button"),r=e==null?void 0:e.querySelector(".buy-button-text"),l=e==null?void 0:e.querySelectorAll(".price"),o=e==null?void 0:e.querySelectorAll(".sale-tag");o==null||o.forEach(u=>u.classList.remove("active")),i==null||i.forEach(u=>u.classList.remove("active"));let d=(E=this.$el.dataset.ids)==null?void 0:E.split(",")[0],f=this.$el.dataset.frameColor,m=this.$el.dataset.lensesColor;l==null||l.forEach(({style:u,dataset:b})=>{u.display=b.id===d?"block":"none"});let p=!1;for(let u of i!=null?i:[]){let b=u.dataset.frameColor,U=u.dataset.lensesColor,S=Number(u.dataset.inventoryQuantity),y=u.dataset.variant,h=u.dataset.id;if(!(!y||!h)){if(this.$el.dataset.isSingleColor){if(b===f&&U===m){u.classList.add("active"),this.id=h,this.variant=y,this.sku=u.dataset.sku||"",p=!0,s&&r&&(s.setAttribute("data-variant",this.variant),S<1?(r.textContent="Sold Out",s.setAttribute("disabled","")):(r.textContent=(T=s.dataset.label)!=null?T:"Buy",s.removeAttribute("disabled")));break}}else if(h===d){u.classList.add("active"),this.id=h,this.variant=y,this.sku=u.dataset.sku||"",p=!0,s&&r&&(s.setAttribute("data-variant",this.variant),S<1?(r.textContent="Sold Out",s.setAttribute("disabled","")):(r.textContent=(M=s.dataset.label)!=null?M:"Buy",s.removeAttribute("disabled")));break}}}!p&&a&&a.classList.add("active");let c=e==null?void 0:e.querySelector(`[data-sale-tag-id=sale-tag-${this.id}]`);c&&c.classList.add("active"),this.updateUrl(),this.syncCalloutPip()},addToCart(){return I(this,null,function*(){let t=C(this.$el);if(!t||t.ariaDisabled==="true")return;let e=this.id!==""?this.id:t.dataset.id;if(!e)return;let a=[H({variantId:e,url:this.url,variantLabel:this.variant,groupId:utils.generateUUID()})];yield this.submitCartAdd(t,a,!1)})},addCrossSellToCart(t,e,a){return I(this,null,function*(){let i=C(this.$el);if(!i||i.ariaDisabled==="true")return;let s=a!==""?a:i.dataset.id;if(!s)return;let r=[H({variantId:s,url:t,variantLabel:e,groupId:utils.generateUUID()})];yield this.submitCartAdd(i,r,!0)})}}));})();

;(() => {
  if (window.twoNuAiTryonCardBridgeLoaded) return;
  window.twoNuAiTryonCardBridgeLoaded = true;

  const masterId = 'ai-tryon-btn';

  function ensureMasterButton() {
    let button = document.getElementById(masterId);
    if (button) return button;

    button = document.createElement('button');
    button.id = masterId;
    button.type = 'button';
    button.tabIndex = -1;
    button.setAttribute('aria-hidden', 'true');
    button.style.cssText = 'position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0;';
    (document.body || document.documentElement).appendChild(button);
    return button;
  }

  function selectedCardImage(trigger) {
    const card = trigger.closest('.card-js');
    if (!card) return null;
    return card.querySelector('.media > img.active[data-id]') || card.querySelector('.media > img.active');
  }

  function titleFromTrigger(trigger, activeImage) {
    const card = trigger.closest('.card-js');
    const productTitle = trigger.dataset.productTitle || card?.querySelector('.card__heading')?.textContent?.trim() || '';
    const variantLabel = activeImage?.dataset.variant || trigger.dataset.variantLabel || '';
    return trigger.dataset.variantTitle || [productTitle, variantLabel ? `(${variantLabel})` : ''].filter(Boolean).join(' ').trim();
  }

  function copyDataToMaster(trigger, master) {
    const activeImage = selectedCardImage(trigger);
    const variantId = activeImage?.dataset.id || trigger.dataset.variantId || master.dataset.variantId || '';
    const variantImage =
      activeImage?.dataset.calloutBaseSrc ||
      activeImage?.currentSrc ||
      activeImage?.src ||
      trigger.dataset.variantImage ||
      master.dataset.variantImage ||
      '';
    const variantTitle = titleFromTrigger(trigger, activeImage) || master.dataset.variantTitle || '';

    master.dataset.productId = trigger.dataset.productId || master.dataset.productId || '';
    master.dataset.variantId = variantId;
    master.dataset.variantImage = variantImage;
    master.dataset.variantTitle = variantTitle;
  }

  function handleTryOnClick(event) {
    const trigger = event.target.closest('[data-ai-tryon-trigger]');
    if (!trigger || trigger.id === masterId) return;

    event.preventDefault();
    const master = ensureMasterButton();
    copyDataToMaster(trigger, master);
    master.dispatchEvent(new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window
    }));
  }

  document.addEventListener('click', handleTryOnClick);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureMasterButton, { once: true });
  } else {
    ensureMasterButton();
  }
})();

;(() => {
  const MARKER = "CODEX_SHOP_ALL_PIP_LAZY_VARIANT_20260626";
  if (window.__twoNuShopAllPipLazyVariantReady) return;
  window.__twoNuShopAllPipLazyVariantReady = true;
  const cache = window.__twoNuShopAllPipLazyVariantCache || (window.__twoNuShopAllPipLazyVariantCache = new Map());
  const isObject = (value) => typeof value === "object" && value !== null;
  const validPip = (item) => isObject(item?.pip) && isObject(item?.main) && typeof item.pip.src === "string" && typeof item.pip.width === "number" && typeof item.pip.height === "number" && typeof item.main.src === "string" && typeof item.main.srcset === "string" && typeof item.main.width === "number" && typeof item.main.height === "number";
  const parseList = (button) => {
    if (!button) return [];
    try {
      const list = JSON.parse(button.dataset.calloutPipList || "[]");
      return Array.isArray(list) ? list.filter(validPip) : [];
    } catch (error) {
      console.error("Shop All lazy PIP list parse error", { error, marker: MARKER });
      return [];
    }
  };
  const setImage = (image, payload) => {
    if (!image || !payload) return;
    image.src = payload.src;
    image.srcset = payload.srcset || "";
    image.width = payload.width;
    image.height = payload.height;
    image.alt = payload.alt || "";
  };
  const normalizeSrc = (src) => String(src || "").replace(/([?&])width=\d+/g, "$1width=x").replace(/[?&]v=\d+/g, "");
  const indexFromButton = (button) => {
    const index = Number(button?.dataset.calloutPipIndex);
    return Number.isFinite(index) && index >= 0 ? index : 0;
  };
  const firstVariantIdFromSwatch = (swatch) => String(swatch?.dataset.ids || "").split(",").map((id) => id.trim()).filter(Boolean)[0] || "";

  const firstVariantIdFromCard = (card) => {
    const activeImageId = String(card?.querySelector?.(".media > img.active")?.dataset?.id || "").trim();
    if (activeImageId) return activeImageId;
    const activeSwatch = card?.querySelector?.(".swatch-wrapper.active, .swatch-wrapper[aria-checked='true'], .swatch-wrapper.selected");
    const swatchId = firstVariantIdFromSwatch(activeSwatch || card?.querySelector?.(".swatch-wrapper"));
    if (swatchId) return swatchId;
    return String(card?.querySelector?.("button.callout-pip[data-callout-pip-id]")?.dataset?.calloutPipId || "").trim();
  };

  const hasVisiblePip = (card) => {
    const button = card?.querySelector?.("button.callout-pip:not([hidden])");
    const image = button?.querySelector?.("img");
    const rect = button?.getBoundingClientRect?.();
    return Boolean(button && image?.getAttribute("src") && rect && rect.width > 8 && rect.height > 8);
  };

  const hydrateLazyPipCards = () => {
    document.querySelectorAll(".card-js[data-shop-all-callout-pip-lazy='true']").forEach((card) => {
      if (hasVisiblePip(card)) return;
      const variantId = firstVariantIdFromCard(card);
      if (!variantId) return;
      updateCardPip(card, variantId).catch((error) => {
        console.error("Callout collection lazy PIP initial hydrate failed", { error, marker: "CODEX_CALLOUT_COLLECTION_PIP_LAZY_INIT_20260701", variantId });
      });
    });
  };

  const scheduleLazyPipHydration = () => {
    window.setTimeout(hydrateLazyPipCards, 120);
    window.setTimeout(hydrateLazyPipCards, 800);
    window.setTimeout(hydrateLazyPipCards, 1800);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scheduleLazyPipHydration, { once: true });
  } else {
    scheduleLazyPipHydration();
  }

  /* CODEX_CALLOUT_COLLECTION_PIP_LAZY_INIT_20260701 */
  const fetchPipData = async (url) => {
    if (!url) return null;
    if (!cache.has(url)) {
      cache.set(url, fetch(url, { credentials: "same-origin", headers: { Accept: "application/json,text/plain,*/*" } }).then(async (response) => {
        const text = await response.text();
        if (!response.ok) throw new Error(`Shop All lazy PIP fetch failed: ${response.status} ${text.slice(0, 160)}`);
        return JSON.parse(text);
      }).catch((error) => {
        cache.delete(url);
        throw error;
      }));
    }
    return cache.get(url);
  };
  const ensureButton = (card) => {
    let button = card.querySelector("button.callout-pip[data-callout-pip='variant']") || card.querySelector("button.callout-pip");
    if (button) return button;
    const media = card.querySelector(".media");
    if (!media) return null;
    button = document.createElement("button");
    button.type = "button";
    button.className = "callout-pip is-active";
    button.dataset.calloutPipLazyCreated = "true";
    button.setAttribute("aria-label", card.querySelector(".card__heading")?.textContent?.trim() || "Product image");
    const image = document.createElement("img");
    image.className = "motion-reduce";
    image.loading = "lazy";
    image.width = 400;
    image.height = 400;
    button.appendChild(image);
    media.appendChild(button);
    return button;
  };
  const updateButton = (card, button, variantId, items) => {
    if (!button || !items.length) return false;
    const mainImage = card.querySelector(`.media > img[data-id="${CSS.escape(variantId)}"]`) || card.querySelector(".media > img.active");
    const baseSrc = mainImage?.dataset?.calloutBaseSrc || mainImage?.currentSrc || mainImage?.src || "";
    let index = 0;
    if (items.length > 1 && normalizeSrc(items[index]?.main?.src) === normalizeSrc(baseSrc)) index = 1;
    button.hidden = false;
    button.classList.add("is-active");
    button.dataset.calloutPip = "variant";
    button.dataset.calloutPipId = variantId;
    button.dataset.calloutPipList = JSON.stringify(items);
    button.dataset.calloutPipIndex = String(index);
    setImage(button.querySelector("img"), items[index].pip);
    return true;
  };
  const updateCardPip = async (card, variantId) => {
    const url = card?.dataset.calloutPipLazyUrl;
    if (!url || !variantId) return false;
    const payload = await fetchPipData(url);
    const items = Array.isArray(payload?.variants?.[variantId]) ? payload.variants[variantId].filter(validPip) : [];
    if (!items.length) return false;
    return updateButton(card, ensureButton(card), variantId, items);
  };
  document.addEventListener("click", (event) => {
    const swatch = event.target?.closest?.(".swatch-wrapper");
    const card = swatch?.closest?.(".card-js[data-shop-all-callout-pip-lazy='true']");
    if (!swatch || !card) return;
    const variantId = firstVariantIdFromSwatch(swatch);
    if (!variantId) return;
    window.setTimeout(() => {
      updateCardPip(card, variantId).catch((error) => console.error("Shop All lazy PIP variant update failed", { error, marker: MARKER, variantId }));
    }, 160);
  }, false);
  document.addEventListener("click", (event) => {
    const button = event.target?.closest?.("button.callout-pip[data-callout-pip-lazy-created='true']");
    if (!button) return;
    const card = button.closest(".card-js");
    const items = parseList(button);
    if (!card || items.length < 2) return;
    const index = indexFromButton(button) % items.length;
    const nextIndex = (index + 1) % items.length;
    setImage(card.querySelector(".media > img.active"), items[index].main);
    setImage(button.querySelector("img"), items[nextIndex].pip);
    button.dataset.calloutPipIndex = String(nextIndex);
  }, false);
})();

;(() => {
  const MARKER = "CODEX_CALLOUT_PIP_LENS_SLIDER_CARD_20260628";
  const RADAR_MARKER = "CODEX_CALLOUT_ACTIVITY_RADAR_20260630";
  if (window.__twoNuCalloutPipLensSliderCardReady) return;
  window.__twoNuCalloutPipLensSliderCardReady = true;

  const isObject = (value) => typeof value === "object" && value !== null;
  const isPipImage = (item) => isObject(item?.pip) && isObject(item?.main) &&
    typeof item.pip.src === "string" &&
    typeof item.main.src === "string";
  const isLensItem = (item) => item?.type === "lens_slider" && isObject(item.scenes);

  const parseList = (button) => {
    if (!button) return [];
    try {
      const list = JSON.parse(button.dataset.calloutPipList || "[]");
      return Array.isArray(list) ? list.filter((item) => isPipImage(item) || isLensItem(item)) : [];
    } catch (error) {
      console.error("callout lens slider PIP list parse error", { error, marker: MARKER });
      return [];
    }
  };

  const hasLensItem = (items) => items.some(isLensItem);
  const indexFromButton = (button) => {
    const index = Number(button?.dataset.calloutPipIndex);
    return Number.isFinite(index) && index >= 0 ? index : 0;
  };
  const setIndex = (button, index) => {
    button.dataset.calloutPipIndex = String(index);
  };

  const setImage = (image, payload) => {
    if (!image || !payload?.src) return;
    image.src = payload.src;
    image.srcset = payload.srcset || "";
    image.width = payload.width || image.width || 400;
    image.height = payload.height || image.height || 400;
    image.alt = payload.alt || "";
  };

  const previewPayload = (item) => {
    if (isLensItem(item)) {
      if (item.pip?.src) return item.pip;
      const scene = item.scenes?.[item.default_scene || "city"] || Object.values(item.scenes || {})[0];
      return {
        src: scene?.thumbnail?.src || item.main?.src || scene?.after?.src || "",
        width: 400,
        height: 400,
        alt: scene?.thumbnail?.alt || item.pip?.alt || "Lens slider",
      };
    }
    return item?.pip;
  };

  const setButtonPreviewPayload = (button, payload) => {
    const image = button?.querySelector("img");
    if (!image || !payload?.src) return;
    image.loading = "eager";
    image.decoding = "async";
    const token = String(Date.now()) + Math.random().toString(36);
    image.dataset.calloutPipPreviewToken = token;
    const apply = () => {
      if (image.dataset.calloutPipPreviewToken === token) setImage(image, payload);
    };
    const preloaded = new Image();
    preloaded.decoding = "async";
    if (payload.srcset) preloaded.srcset = payload.srcset;
    preloaded.onload = apply;
    preloaded.onerror = apply;
    preloaded.src = payload.src;
    if (preloaded.complete) {
      apply();
    } else if (typeof preloaded.decode === "function") {
      preloaded.decode().then(apply).catch(() => {});
    }
  };

  const setButtonPreview = (button, item) => {
    setButtonPreviewPayload(button, previewPayload(item));
  };

  const cardFromButton = (button) => button?.closest?.(".card-js");
  const mediaFromCard = (card) => card?.querySelector?.(".media");
  const activeMainImage = (card) => card?.querySelector?.(".media > img.active");
  const activePipButton = (card) => card?.querySelector?.("button.callout-pip.is-active:not([hidden])");

  const normalizeImagePath = (src) => {
    try {
      const url = new URL(String(src || ""), window.location.origin);
      return url.pathname;
    } catch {
      return String(src || "").replace(/^https?:/, "").split("?")[0];
    }
  };

  const basePayload = (card) => {
    const image = activeMainImage(card);
    const src = image?.dataset?.calloutBaseSrc || "";
    if (!src) return null;
    return {
      src,
      srcset: image.dataset.calloutBaseSrcset || "",
      width: Number(image.dataset.calloutBaseWidth) || image.width || 400,
      height: Number(image.dataset.calloutBaseHeight) || image.height || 400,
      alt: image.dataset.calloutBaseAlt || image.alt || "",
    };
  };

  const listIncludesBaseImage = (card, items) => {
    const base = basePayload(card);
    if (!base?.src) return true;
    const basePath = normalizeImagePath(base.src);
    return items.some((item) => isPipImage(item) && normalizeImagePath(item.main?.src) === basePath);
  };

  const shouldUseVirtualBase = (card, items) => !!basePayload(card)?.src && !listIncludesBaseImage(card, items);

  const hideLensCard = (card) => {
    if (!card) return;
    card.classList.remove("is-callout-lens-slider-active");
    const panel = card.querySelector("[data-callout-lens-slider-card]");
    if (panel) {
      panel.hidden = true;
      panel.classList.remove("has-activity-radar");
    }
  };

  const visibleIndexFromCard = (card) => {
    const index = Number(card?.dataset.calloutPipVisibleIndex);
    return Number.isFinite(index) && index >= 0 ? index : null;
  };

  const setVisibleIndex = (card, index) => {
    if (card) card.dataset.calloutPipVisibleIndex = String(index);
  };

  const setVisibleBase = (card) => {
    if (card) card.dataset.calloutPipVisibleIndex = "base";
  };

  const sceneKeys = (item) => Object.keys(item?.scenes || {}).filter((key) => isObject(item.scenes[key]));

  const ensureLensCard = (card) => {
    const media = mediaFromCard(card);
    if (!media) return null;
    let panel = media.querySelector("[data-callout-lens-slider-card]");
    if (panel) return panel;

    panel = document.createElement("div");
    panel.className = "callout-lens-slider-card";
    panel.dataset.calloutLensSliderCard = "";
    panel.hidden = true;
    panel.innerHTML = `
      <div class="callout-lens-slider-card__stage" data-callout-lens-stage style="--callout-lens-pos: 50%;">
        <img class="callout-lens-slider-card__image callout-lens-slider-card__image--after" data-callout-lens-after alt="" loading="lazy">
        <div class="callout-lens-slider-card__before" data-callout-lens-before-wrap>
          <img class="callout-lens-slider-card__image callout-lens-slider-card__image--before" data-callout-lens-before alt="" loading="lazy">
        </div>
        <span class="callout-lens-slider-card__label callout-lens-slider-card__label--before" data-callout-lens-before-label hidden aria-hidden="true"></span>
        <span class="callout-lens-slider-card__label callout-lens-slider-card__label--after" data-callout-lens-after-label></span>
        <div class="callout-lens-slider-card__activity-radar" data-callout-activity-radar hidden>
          <canvas class="callout-lens-slider-card__activity-radar-canvas" data-callout-activity-radar-canvas role="img"></canvas>
          <span class="visually-hidden" data-callout-activity-radar-summary></span>
        </div>
        <span class="callout-lens-slider-card__handle" aria-hidden="true"></span>
        <input class="callout-lens-slider-card__range" data-callout-lens-range type="range" min="8" max="92" value="50" aria-label="Compare lens effect">
      </div>
      <div class="callout-lens-slider-card__scenes" data-callout-lens-scenes role="group" aria-label="Lens view scene"></div>
    `;
    media.appendChild(panel);
    return panel;
  };

  const scoreAxes = (i18n = {}) => {
    const labels = i18n.axes || {};
    return [
      { key: "running", label: labels.running || "Run" },
      { key: "trail", label: labels.trail || "Trail" },
      { key: "water", label: labels.water || "Water" },
      { key: "cycling", label: labels.cycling || "Cycle" },
      { key: "driving", label: labels.driving || "Drive" },
      { key: "golf", label: labels.golf || "Golf" },
      { key: "everyday", label: labels.everyday || "Daily" },
      { key: "alpine", label: labels.alpine || "ALPINE" },
    ];
  };

  const normalizeScores = (item, axes) => {
    const raw = item?.activity_scores;
    if (!isObject(raw)) return null;
    const scores = {};
    let hasScore = false;
    axes.forEach((axis) => {
      const value = Number(raw[axis.key]);
      scores[axis.key] = Number.isFinite(value) ? Math.max(0, Math.min(5, value)) : 0;
      if (scores[axis.key] > 0) hasScore = true;
    });
    return hasScore ? scores : null;
  };

  const radarPointAt = (center, radius, axes, index, score = 5) => {
    const angle = (-Math.PI / 2) + ((Math.PI * 2 * index) / axes.length);
    const scaledRadius = radius * (score / 5);
    return {
      x: center + Math.cos(angle) * scaledRadius,
      y: center + Math.sin(angle) * scaledRadius,
    };
  };

  const drawRadarPolygon = (context, points) => {
    context.beginPath();
    points.forEach((point, index) => {
      if (index === 0) context.moveTo(point.x, point.y);
      else context.lineTo(point.x, point.y);
    });
    context.closePath();
  };

  const drawActivityRadar = (canvas, item) => {
    const i18n = item?.activity_radar_i18n || {};
    const axes = scoreAxes(i18n);
    const scores = normalizeScores(item, axes);
    if (!scores) return false;

    const rect = canvas.getBoundingClientRect();
    const cssSize = Math.max(111, Math.round(Math.min(rect.width || 165, 219)));
    const dpr = Math.max(1, window.devicePixelRatio || 1);
    canvas.width = Math.round(cssSize * dpr);
    canvas.height = Math.round(cssSize * dpr);
    canvas.style.height = cssSize + "px";

    const context = canvas.getContext("2d");
    context.setTransform(dpr, 0, 0, dpr, 0, 0);
    context.clearRect(0, 0, cssSize, cssSize);

    const center = cssSize / 2;
    const radius = cssSize * 0.29;
    const basePoints = axes.map((axis, index) => radarPointAt(center, radius, axes, index, 5));
    drawRadarPolygon(context, basePoints);
    const baseGradient = context.createRadialGradient(center, center, radius * 0.08, center, center, radius);
    baseGradient.addColorStop(0, "rgba(0, 68, 73, .10)");
    baseGradient.addColorStop(0.68, "rgba(0, 68, 73, .18)");
    baseGradient.addColorStop(1, "rgba(0, 68, 73, .30)");
    context.fillStyle = baseGradient;
    context.fill();
    context.lineJoin = "round";
    context.lineWidth = Math.max(1, cssSize * .008);
    context.strokeStyle = "rgba(0, 68, 73, .36)";
    context.stroke();

    const scorePoints = axes.map((axis, index) => radarPointAt(center, radius, axes, index, scores[axis.key]));
    drawRadarPolygon(context, scorePoints);
    const scoreGradient = context.createRadialGradient(center, center, 0, center, center, radius);
    scoreGradient.addColorStop(0, "rgba(0, 68, 73, .24)");
    scoreGradient.addColorStop(0.62, "rgba(0, 68, 73, .42)");
    scoreGradient.addColorStop(1, "rgba(0, 68, 73, .62)");
    context.fillStyle = scoreGradient;
    context.fill();
    context.lineJoin = "round";
    context.lineWidth = Math.max(2, cssSize * .016);
    context.strokeStyle = "#0BF477";
    context.shadowColor = "rgba(11, 244, 119, .48)";
    context.shadowBlur = Math.max(2, cssSize * .024);
    context.stroke();
    context.shadowBlur = 0;

    context.beginPath();
    context.arc(center, center, Math.max(1.3, cssSize * .012), 0, Math.PI * 2);
    context.fillStyle = "rgba(0, 68, 73, .72)";
    context.fill();

    const labelFontSize = Math.max(6.8, Math.min(10.5, cssSize * 0.066));
    const labelOffset = cssSize * 0.082;
    context.font = "800 " + labelFontSize + "px Inter, Arial, sans-serif";
    context.fillStyle = "#0BF477";
    context.textAlign = "center";
    context.textBaseline = "middle";
    context.shadowColor = "rgba(0, 68, 73, .82)";
    context.shadowBlur = Math.max(1.5, cssSize * .016);
    axes.forEach((axis, index) => {
      const labelPoint = radarPointAt(center, radius + labelOffset, axes, index);
      context.fillText(axis.label, labelPoint.x, labelPoint.y);
    });
    context.shadowBlur = 0;

    const outOfFive = i18n.outOfFive || "out of 5";
    const chartLabel = i18n.chartLabel || "Activity suitability radar chart";
    const scoresLabel = i18n.scoresLabel || "Activity suitability scores";
    const text = axes.map((axis) => axis.label + " " + scores[axis.key] + " " + outOfFive).join(", ");
    canvas.setAttribute("aria-label", chartLabel + ": " + text);
    const summary = canvas.parentElement?.querySelector?.("[data-callout-activity-radar-summary]");
    if (summary) summary.textContent = scoresLabel + ": " + text + ".";
    return true;
  };

  const renderActivityRadar = (panel, item) => {
    const radar = panel?.querySelector?.("[data-callout-activity-radar]");
    const canvas = panel?.querySelector?.("[data-callout-activity-radar-canvas]");
    if (!radar || !canvas) return;
    const shown = drawActivityRadar(canvas, item);
    radar.hidden = !shown;
    panel.classList.toggle("has-activity-radar", shown);
  };

  const setStagePosition = (stage, value) => {
    const clamped = Math.max(8, Math.min(92, Number(value) || 50));
    stage?.style?.setProperty("--callout-lens-pos", clamped + "%");
    const range = stage?.querySelector?.("[data-callout-lens-range]");
    if (range) range.value = String(clamped);
  };

  const setStagePositionFromClientX = (stage, clientX) => {
    const rect = stage?.getBoundingClientRect?.();
    if (!rect || rect.width <= 0) return;
    const percent = ((Number(clientX) - rect.left) / rect.width) * 100;
    setStagePosition(stage, percent);
  };

  const lensDrag = {
    stage: null,
    pointerId: null,
    startX: 0,
    startY: 0,
    horizontal: false,
  };

  const lensStageFromEvent = (event) => {
    const stage = event.target?.closest?.("[data-callout-lens-stage]");
    const panel = stage?.closest?.("[data-callout-lens-slider-card]");
    if (!stage || !panel || panel.hidden) return null;
    return stage;
  };

  const touchPoint = (event) => {
    const touch = event.changedTouches?.[0] || event.touches?.[0];
    return touch ? { x: touch.clientX, y: touch.clientY } : null;
  };

  const pointerPoint = (event) => ({ x: event.clientX, y: event.clientY });

  const beginLensDrag = (event, point) => {
    const stage = lensStageFromEvent(event);
    if (!stage || !point) return;
    lensDrag.stage = stage;
    lensDrag.pointerId = event.pointerId ?? null;
    lensDrag.startX = point.x;
    lensDrag.startY = point.y;
    lensDrag.horizontal = false;
    stage.dataset.calloutLensDragging = "true";
    if (event.pointerId !== undefined) stage.setPointerCapture?.(event.pointerId);
    setStagePositionFromClientX(stage, point.x);
    event.stopPropagation();
  };

  const moveLensDrag = (event, point) => {
    const stage = lensDrag.stage || lensStageFromEvent(event);
    if (!stage || !point) return;
    if (lensDrag.pointerId !== null && event.pointerId !== undefined && event.pointerId !== lensDrag.pointerId) return;
    const dx = Math.abs(point.x - lensDrag.startX);
    const dy = Math.abs(point.y - lensDrag.startY);
    if (lensDrag.horizontal || dx > 4) {
      lensDrag.horizontal = dx >= dy || lensDrag.horizontal;
    }
    if (lensDrag.horizontal) {
      event.preventDefault();
      setStagePositionFromClientX(stage, point.x);
    }
    event.stopPropagation();
  };

  const endLensDrag = (event) => {
    const stage = lensDrag.stage || lensStageFromEvent(event);
    if (!stage) return;
    if (lensDrag.pointerId !== null && event.pointerId !== undefined && event.pointerId !== lensDrag.pointerId) return;
    if (event.pointerId !== undefined) stage.releasePointerCapture?.(event.pointerId);
    delete stage.dataset.calloutLensDragging;
    lensDrag.stage = null;
    lensDrag.pointerId = null;
    lensDrag.horizontal = false;
    event.stopPropagation();
  };

  const setScene = (panel, item, sceneKey) => {
    const scenes = item?.scenes || {};
    const fallbackKey = scenes[sceneKey] ? sceneKey : (scenes[item.default_scene] ? item.default_scene : sceneKeys(item)[0]);
    const scene = scenes[fallbackKey];
    if (!scene) return;

    panel.dataset.activeScene = fallbackKey;
    const before = panel.querySelector("[data-callout-lens-before]");
    const after = panel.querySelector("[data-callout-lens-after]");
    const beforeLabel = panel.querySelector("[data-callout-lens-before-label]");
    const afterLabel = panel.querySelector("[data-callout-lens-after-label]");
    if (before) {
      before.src = scene.before?.src || "";
      before.alt = scene.before?.alt || "";
    }
    if (after) {
      after.src = scene.after?.src || "";
      after.alt = scene.after?.alt || "";
    }
    if (beforeLabel) {
      beforeLabel.textContent = "";
      beforeLabel.hidden = true;
      beforeLabel.setAttribute("aria-hidden", "true");
    }
    if (afterLabel) afterLabel.textContent = scene.after_label || "";

    panel.querySelectorAll("[data-callout-lens-scene]").forEach((button) => {
      const active = button.dataset.calloutLensScene === fallbackKey;
      button.classList.toggle("active", active);
      button.setAttribute("aria-pressed", active ? "true" : "false");
    });
  };

  const renderSceneButtons = (panel, item) => {
    const holder = panel.querySelector("[data-callout-lens-scenes]");
    if (!holder) return;
    const keys = sceneKeys(item);
    holder.innerHTML = keys.map((key) => {
      const scene = item.scenes[key] || {};
      const label = scene.label || key;
      const thumb = scene.thumbnail?.src || scene.after?.src || "";
      const alt = scene.thumbnail?.alt || label + " scene";
      return `
        <button type="button" class="callout-lens-slider-card__scene" data-callout-lens-scene="${key}" aria-pressed="false">
          <img src="${thumb}" alt="${alt}" loading="lazy">
          <span>${label}</span>
        </button>
      `;
    }).join("");
  };

  const showLensCard = (card, button, item, nextItem, nextPayload = null) => {
    const panel = ensureLensCard(card);
    if (!panel) return;
    card.classList.remove("is-callout-pip-swapped");
    card.classList.add("is-callout-lens-slider-active");
    renderSceneButtons(panel, item);
    setScene(panel, item, panel.dataset.activeScene || item.default_scene || "city");
    const stage = panel.querySelector("[data-callout-lens-stage]");
    const range = panel.querySelector("[data-callout-lens-range]");
    if (range) {
      range.value = "50";
      setStagePosition(stage, 50);
    }
    panel.hidden = false;
    renderActivityRadar(panel, item);
    window.requestAnimationFrame(() => renderActivityRadar(panel, item));
    if (nextPayload) {
      setButtonPreviewPayload(button, nextPayload);
    } else {
      setButtonPreview(button, nextItem);
    }
  };

  const renderVirtualBase = (card, button, items) => {
    const base = basePayload(card);
    if (!base?.src) return false;
    hideLensCard(card);
    card.classList.remove("is-callout-pip-swapped");
    const main = activeMainImage(card);
    if (main) setImage(main, base);
    const nextIndex = Math.max(0, items.findIndex(isPipImage));
    const nextItem = items[nextIndex];
    setButtonPreview(button, nextItem);
    setVisibleBase(card);
    setIndex(button, nextIndex);
    return true;
  };

  const renderLensAwarePipIndex = (card, button, items, index) => {
    if (!card || !button || !hasLensItem(items) || items.length < 2) return false;
    const safeIndex = Math.max(0, Number(index) || 0) % items.length;
    const current = items[safeIndex];
    const nextIndex = (safeIndex + 1) % items.length;
    const next = items[nextIndex];

    if (isLensItem(current)) {
      showLensCard(
        card,
        button,
        current,
        next,
        shouldUseVirtualBase(card, items) ? basePayload(card) : null,
      );
    } else {
      hideLensCard(card);
      const main = activeMainImage(card);
      if (main && current?.main) setImage(main, current.main);
      setButtonPreview(button, next);
    }

    setVisibleIndex(card, safeIndex);
    setIndex(button, nextIndex);
    return true;
  };

  const cycleLensAwarePip = (button) => {
    const items = parseList(button);
    if (!hasLensItem(items) || items.length < 2) return false;
    const card = cardFromButton(button);
    if (!card) return false;
    const panel = card.querySelector("[data-callout-lens-slider-card]");
    const lensActive = card.classList.contains("is-callout-lens-slider-active") && panel && !panel.hidden;
    const lensIndex = items.findIndex(isLensItem);
    if (lensActive && lensIndex >= 0 && shouldUseVirtualBase(card, items)) {
      return renderVirtualBase(card, button, items);
    }
    const index = lensActive && lensIndex >= 0
      ? (lensIndex + 1) % items.length
      : indexFromButton(button);
    return renderLensAwarePipIndex(card, button, items, index);
  };

  const restoreVisiblePipIndex = (card, requestedIndex, requestedScene) => {
    const button = activePipButton(card);
    const items = parseList(button);
    if (!button || !hasLensItem(items) || items.length < 2) return false;
    const panel = card?.querySelector?.("[data-callout-lens-slider-card]");
    if (panel && requestedScene) panel.dataset.activeScene = requestedScene;
    const targetIndex = requestedIndex === "lens"
      ? Math.max(0, items.findIndex(isLensItem))
      : requestedIndex;
    return renderLensAwarePipIndex(card, button, items, targetIndex);
  };

  const preserveVisiblePipAfterSwatch = (card) => {
    const button = activePipButton(card);
    const items = parseList(button);
    if (!button || !hasLensItem(items) || items.length < 2) return;

    const visibleIndex = visibleIndexFromCard(card);
    const panel = card.querySelector("[data-callout-lens-slider-card]");
    const lensActive = card.classList.contains("is-callout-lens-slider-active") && panel && !panel.hidden;
    if (visibleIndex === null && !lensActive) return;

    const requestedIndex = lensActive || (visibleIndex !== null && isLensItem(items[visibleIndex]))
      ? "lens"
      : visibleIndex !== null
        ? visibleIndex
        : Math.max(0, items.findIndex(isLensItem));
    const requestedScene = panel?.dataset?.activeScene || "";
    hideLensCard(card);

    window.setTimeout(() => restoreVisiblePipIndex(card, requestedIndex, requestedScene), 260);
    window.setTimeout(() => restoreVisiblePipIndex(card, requestedIndex, requestedScene), 720);
  };

  document.addEventListener("click", (event) => {
    const button = event.target?.closest?.("button.callout-pip");
    if (!button) return;
    const items = parseList(button);
    if (!hasLensItem(items)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    cycleLensAwarePip(button);
  }, true);

  document.addEventListener("click", (event) => {
    const sceneButton = event.target?.closest?.("[data-callout-lens-scene]");
    if (!sceneButton) return;
    const panel = sceneButton.closest("[data-callout-lens-slider-card]");
    const button = panel?.closest?.(".media")?.querySelector?.("button.callout-pip.is-active:not([hidden])");
    const lensItem = parseList(button).find(isLensItem);
    if (!panel || !lensItem) return;
    event.preventDefault();
    event.stopPropagation();
    setScene(panel, lensItem, sceneButton.dataset.calloutLensScene);
    renderActivityRadar(panel, lensItem);
  });

  document.addEventListener("input", (event) => {
    const range = event.target?.closest?.("[data-callout-lens-range]");
    if (!range) return;
    setStagePosition(range.closest("[data-callout-lens-stage]"), range.value);
  });

  window.addEventListener("resize", () => {
    document.querySelectorAll("[data-callout-lens-slider-card]:not([hidden])").forEach((panel) => {
      const button = panel.closest?.(".media")?.querySelector?.("button.callout-pip.is-active:not([hidden])");
      const lensItem = parseList(button).find(isLensItem);
      if (lensItem) renderActivityRadar(panel, lensItem);
    });
  });

  if (typeof window.PointerEvent === "function") {
    document.addEventListener("pointerdown", (event) => {
      if (event.button !== undefined && event.button !== 0) return;
      beginLensDrag(event, pointerPoint(event));
    }, true);

    document.addEventListener("pointermove", (event) => {
      moveLensDrag(event, pointerPoint(event));
    }, { capture: true, passive: false });

    document.addEventListener("pointerup", endLensDrag, true);
    document.addEventListener("pointercancel", endLensDrag, true);
  } else {
    document.addEventListener("touchstart", (event) => {
      beginLensDrag(event, touchPoint(event));
    }, { capture: true, passive: true });

    document.addEventListener("touchmove", (event) => {
      moveLensDrag(event, touchPoint(event));
    }, { capture: true, passive: false });

    document.addEventListener("touchend", endLensDrag, true);
    document.addEventListener("touchcancel", endLensDrag, true);
  }

  document.addEventListener("click", (event) => {
    const swatch = event.target?.closest?.(".swatch-wrapper");
    const card = swatch?.closest?.(".card-js");
    if (card) preserveVisiblePipAfterSwatch(card);
  }, true);
})();


;(() => {
  const MARKER = "CODEX_BOGO_LENS_FAMILY_V2_PIP_FALLBACK_20260703";
  if (window.__twoNuBogoLensFamilyV2PipFallbackReady) return;
  window.__twoNuBogoLensFamilyV2PipFallbackReady = true;

  const parseList = (button) => {
    try {
      const list = JSON.parse(button?.dataset?.calloutPipList || "[]");
      return Array.isArray(list) ? list.filter((item) => item?.pip?.src && item?.main?.src) : [];
    } catch (error) {
      console.error("Lens-family-v2 fallback PIP parse failed", { error, marker: MARKER });
      return [];
    }
  };

  const setPipImage = (button, item) => {
    const image = button?.querySelector?.("img");
    if (!image || !item?.pip?.src) return;
    image.src = item.pip.src;
    image.srcset = item.pip.srcset || "";
    image.width = item.pip.width || image.width || 400;
    image.height = item.pip.height || image.height || 400;
    image.alt = item.pip.alt || image.alt || "";
  };

  const normalizeSrc = (src) => String(src || "")
    .replace(/([?&])width=\d+/g, "$1width=x")
    .replace(/[?&]v=\d+/g, "");

  const isVisible = (button) => {
    if (!button || button.hidden) return false;
    const style = getComputedStyle(button);
    const rect = button.getBoundingClientRect();
    return style.display !== "none" && style.visibility !== "hidden" && rect.width > 8 && rect.height > 8;
  };

  const repairCard = (card) => {
    const buttons = Array.from(card.querySelectorAll("button.callout-pip"));
    if (!buttons.length || buttons.some(isVisible)) return;

    const fallback = buttons.find((button) => parseList(button).length) || buttons[0];
    buttons.forEach((button) => {
      const active = button === fallback;
      button.hidden = !active;
      button.classList.toggle("is-active", active);
    });

    const items = parseList(fallback);
    if (items.length) {
      const activeMain = card.querySelector(".media > img.active");
      const activeSrc = normalizeSrc(activeMain?.dataset?.calloutBaseSrc || activeMain?.currentSrc || activeMain?.src || "");
      let index = 0;
      if (items.length > 1 && normalizeSrc(items[index]?.main?.src) === activeSrc) index = 1;
      fallback.dataset.calloutPipIndex = String(index);
      setPipImage(fallback, items[index]);
    }
  };

  const repairAll = () => {
    document.querySelectorAll(".callout-lens-family-v2 .card-js").forEach(repairCard);
  };

  const scheduleRepair = () => {
    window.setTimeout(repairAll, 80);
    window.setTimeout(repairAll, 300);
    window.setTimeout(repairAll, 900);
  };

  document.addEventListener("click", (event) => {
    if (event.target?.closest?.(".callout-lens-family-v2 .swatch-wrapper, .callout-lens-family-v2__family-button")) {
      scheduleRepair();
    }
  }, false);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scheduleRepair, { once: true });
  } else {
    scheduleRepair();
  }
})();


;(() => {
  const MARKER = "CODEX_V1423_CALLOUT_LAYOUT_SKU_JS_20260713";
  if (window.__twoNuApprovedCalloutLayoutReady) return;
  window.__twoNuApprovedCalloutLayoutReady = true;

  const directChild = (parent, selector) => {
    if (!parent) return null;
    return Array.from(parent.children || []).find((child) => child.matches?.(selector)) || null;
  };

  const mountCard = (card) => {
    if (!(card instanceof HTMLElement) || card.dataset.calloutLayoutReady === "true") return;

    const overlay = directChild(card, ".card__swatch-overlay");
    const mediaShell = card.querySelector(".card__inner");
    if (overlay && mediaShell && overlay.parentElement !== mediaShell) mediaShell.appendChild(overlay);

    if (card.closest(".callout-lens-family-v2")) {
      const originalParent = card.parentElement;
      const controls = directChild(originalParent, ".callout-lens-family-v2__controls") || card.querySelector(":scope > .callout-lens-family-v2__controls");
      if (controls && controls.parentElement !== card) card.appendChild(controls);

      const actions = directChild(card, ".card__callout-actions") || card.querySelector(".card__callout-actions");
      const fit = directChild(controls, ".callout-lens-family-v2__fit");
      if (controls && actions && actions.parentElement !== controls) controls.insertBefore(actions, fit || controls.children[1] || null);
    }

    card.dataset.calloutLayoutReady = "true";
  };

  const boot = (root = document) => root.querySelectorAll?.(".card-js--callout[data-callout-card='true']").forEach(mountCard);
  const schedule = (root = document) => {
    boot(root);
    window.requestAnimationFrame(() => boot(root));
    window.setTimeout(() => boot(root), 180);
  };

  const mountAddedNode = (node) => {
    if (!(node instanceof Element)) return;
    if (node.matches(".card-js--callout[data-callout-card='true']")) mountCard(node);
    boot(node);
  };

  const observeReplacedSections = () => {
    if (window.__twoNuApprovedCalloutLayoutObserver || !document.documentElement) return;
    const observer = new MutationObserver((records) => {
      records.forEach((record) => record.addedNodes.forEach(mountAddedNode));
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.__twoNuApprovedCalloutLayoutObserver = observer;
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      schedule(document);
      observeReplacedSections();
    }, { once: true });
  } else {
    schedule(document);
    observeReplacedSections();
  }

  document.addEventListener("shopify:section:load", (event) => schedule(event.target));
})();

;(() => {
  const MARKER = "CODEX_V1423_FEEDBACK_SWATCH_HINT_JS_20260713";
  if (window.__twoNuSwatchOverflowHintReady) return;
  window.__twoNuSwatchOverflowHintReady = true;

  const arrowSvg = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 12h13M13 7l5 5-5 5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.2"/></svg>';

  const setup = (card) => {
    if (!(card instanceof HTMLElement)) return;
    const overlay = card.querySelector(".card__swatch-overlay");
    const mediaShell = card.querySelector(".card__inner");
    if (!overlay || !mediaShell || overlay.dataset.swatchOverflowHintReady === "true") return;

    let hint = mediaShell.querySelector(":scope > .card__swatch-overflow-hint");
    if (!hint) {
      hint = document.createElement("span");
      hint.className = "card__swatch-overflow-hint";
      hint.setAttribute("aria-hidden", "true");
      hint.hidden = true;
      hint.innerHTML = arrowSvg;
      mediaShell.appendChild(hint);
    }

    let frame = 0;
    const update = () => {
      frame = 0;
      const maxScroll = Math.max(0, overlay.scrollWidth - overlay.clientWidth);
      const currentScroll = Math.abs(overlay.scrollLeft);
      const overflowing = maxScroll > 2;
      const atEnd = currentScroll >= maxScroll - 2;
      card.classList.toggle("card-js--swatches-overflow", overflowing);
      hint.hidden = !overflowing || atEnd;
    };
    const schedule = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(update);
    };

    overlay.dataset.swatchOverflowHintReady = "true";
    overlay.addEventListener("scroll", schedule, { passive: true });
    window.addEventListener("resize", schedule, { passive: true });
    if ("ResizeObserver" in window) {
      const observer = new ResizeObserver(schedule);
      observer.observe(overlay);
      observer.observe(mediaShell);
      card.__twoNuSwatchOverflowObserver = observer;
    }
    const mutationObserver = new MutationObserver(schedule);
    mutationObserver.observe(overlay, {
      attributes: true,
      attributeFilter: ["class", "hidden", "style"],
      childList: true,
      subtree: true,
    });
    card.__twoNuSwatchOverflowMutationObserver = mutationObserver;
    schedule();
    window.setTimeout(schedule, 220);
  };

  const boot = (root = document) => root.querySelectorAll?.(".card-js--callout[data-callout-card='true']").forEach(setup);
  const mountAddedNode = (node) => {
    if (!(node instanceof Element)) return;
    if (node.matches(".card-js--callout[data-callout-card='true']")) setup(node);
    boot(node);
  };
  const observe = () => {
    if (window.__twoNuSwatchOverflowHintObserver || !document.documentElement) return;
    const observer = new MutationObserver((records) => records.forEach((record) => record.addedNodes.forEach(mountAddedNode)));
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.__twoNuSwatchOverflowHintObserver = observer;
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      boot(document);
      observe();
    }, { once: true });
  } else {
    boot(document);
    observe();
  }

  document.addEventListener("shopify:section:load", (event) => boot(event.target));
})();
